import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Link as LoftLink } from "@xometry/xometry_loft";

export const HeroContentPostDownloadBackground = styled.div`
  background: ${theme.colors.darkBlues[5]};
  width: 100%;
`;

export const HeroContentPostDownloadBase = styled.div`
  padding: 28px 36px 32px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${theme.maxWidth};
  margin: 0 auto;

  ${theme.largerThan.xl} {
    padding: 48px 5% 0;
    flex-direction: row;
    align-items: flex-start;
    max-height: 500px;
  }
`;

export const HeroText = styled.div`
  flex: 1 1 auto;
`;

export const BreadcrumbsWrapper = styled.div`
  margin: 0 0 16px 0;

  ${theme.largerThan.lg} {
    margin: 0 0 24px 0;
  }
`;

export const Text = styled.div`
  ${theme.largerThan.xl} {
    margin-right: 80px;
  }
`;

export const Title = styled.h1`
  margin: 0 0 20px 0;

  ${theme.largerThan.sm} {
    margin: 0 0 24px 0;
  }
`;

export const Subtitle = styled.h4`
  margin-bottom: 32px;
`;

export const Form = styled.div`
  background: #ffffff;
  flex: 1 0 auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 0 25px 0 ${theme.colors.darkBlues[100]}15;
  z-index: 1;

  ${theme.largerThan.xl} {
    max-width: 420px;
    padding: 40px 32px;
  }
`;

export const FormTitle = styled.h4`
  color: ${theme.colors.darkBlues[90]};
  flex: 0 1 auto;
`;

export const ImageClassName = `
  flex: 0 1 auto;
  width: 100%;
  max-height: fit-content;
  margin-bottom: 16px;
`;

export const FormSubtitle = styled.div`
  color: ${theme.colors.darkBlues[90]};
  font-size: 16px;
  line-height: 24px;
  flex: 0 1 auto;
  text-align: center;
`;
